module.exports = __webpack_public_path__ + "static/media/img_Inscription_name1.bd5f743f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_Inscription_name1.png
// module id = 988
// module chunks = 0